import { render, staticRenderFns } from "./ExtInfo.vue?vue&type=template&id=576b52e4&"
import script from "./ExtInfo.vue?vue&type=script&lang=js&"
export * from "./ExtInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExtInfo.vue?vue&type=style&index=0&id=576b52e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports